import { render, staticRenderFns } from "./CalendarList.vue?vue&type=template&id=94b8c880"
import script from "./CalendarList.vue?vue&type=script&lang=js"
export * from "./CalendarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports